import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e294a8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "re-login" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重新登录")

import { StoreSessionMutations } from '@/lib/store/modules/session/mutations'
import { useRouter } from 'vue-router'
import { IIdCard, ShopRole } from '@/interface'
import store from '@/lib/store'
import { StoreCashierActions } from '@/lib/store/modules/cashier/actions'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const idCards = store.state.session.id_cards

const topic = (key: string): string => {
  if (key.startsWith('http')) {
    return key
  } else {
    return `https://c.s.mywsy.cn/${key}-sq.200`
  }
}

const getRole = (idCard: IIdCard): string => {
  if (idCard.creator.role === ShopRole.Boss) {
    return '老板'
  } else if (idCard.creator.privilege_data) {
    return '股东'
  } else {
    return '收银员'
  }
}

const onPick = (idCard: IIdCard) => {
  store.commit(StoreSessionMutations.join, idCard)
  store.dispatch(StoreCashierActions.onJoin, idCard)
  router.push({ name: 'workspace' })
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/auth/login" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_list, { size: "large" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(idCards), (idCard, index) => {
          return (_openBlock(), _createBlock(_component_a_list_item, { key: index }, {
            default: _withCtx(() => [
              _createVNode(_component_a_list_item_meta, {
                description: idCard.shop.sid + ' ['+getRole(idCard)+']',
                onClick: ($event: any) => (onPick(idCard))
              }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(idCard.shop.shop_name), 1)
                ]),
                avatar: _withCtx(() => [
                  _createVNode(_component_a_avatar, {
                    src: topic(idCard.shop.icon)
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1032, ["description", "onClick"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})